// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"by-name-m__wrapper__3DcJp","time-ago":"by-name-m__time-ago___bzZe"};